export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "pdf.worker.entry-1db78367e6dec4081b2b.worker.js");
}
